import { render, staticRenderFns } from "./pdf-document-viewer.vue?vue&type=template&id=9953738c&scoped=true&"
import script from "./pdf-document-viewer.vue?vue&type=script&lang=js&"
export * from "./pdf-document-viewer.vue?vue&type=script&lang=js&"
import style0 from "./pdf-document-viewer.vue?vue&type=style&index=0&id=9953738c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9953738c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
